import React, { useState } from 'react';
import { Search, ChevronRight } from 'lucide-react';
import { locations } from '../data/mock';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const JobSearch = () => {
  const [location, setLocation] = useState('');
  const [keyword, setKeyword] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('Searching:', { location, keyword });
  };

  return (
    <section className="bg-white py-12 -mt-16 relative z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <h2 className="text-2xl font-serif text-gray-800 mb-6">À la recherche d'un emploi?</h2>
          
          <form onSubmit={handleSearch} className="flex flex-col md:flex-row gap-4">
            {/* Location Select */}
            <div className="flex-1">
              <Select value={location} onValueChange={setLocation}>
                <SelectTrigger className="w-full h-12 border-gray-300 focus:border-[#E30022] focus:ring-[#E30022]">
                  <SelectValue placeholder="Localisation" />
                </SelectTrigger>
                <SelectContent>
                  {locations.filter(l => l.value).map((loc) => (
                    <SelectItem key={loc.value} value={loc.value}>
                      {loc.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Keyword Input */}
            <div className="flex-1">
              <input
                type="text"
                placeholder="Mot-clé, métier, entreprise..."
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                className="w-full h-12 px-4 border border-gray-300 rounded-md focus:border-[#E30022] focus:ring-1 focus:ring-[#E30022] outline-none transition-colors"
              />
            </div>

            {/* Search Button */}
            <button
              type="submit"
              className="h-12 px-8 bg-[#E30022] text-white rounded-md hover:bg-[#c7001d] transition-colors flex items-center justify-center gap-2 font-medium"
            >
              <Search className="h-5 w-5" />
              Rechercher
            </button>
          </form>

          {/* Link for employers */}
          <a 
            href="/recrutement" 
            className="inline-flex items-center gap-2 mt-6 text-[#E30022] hover:underline font-medium group"
          >
            Vous cherchez des collaborateurs?
            <ChevronRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default JobSearch;
